import React, { memo } from 'react';
import { LoadableImage } from '@app/components';
import placeholderImage from './placeholder.png';

interface Props {
  images: string[];
  placeholder?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

function CardThumb(props: Props) {
  const { images, placeholder, onClick = () => {} } = props;

  return (
    <div onClick={onClick} className="w-full h-full">
      <LoadableImage
        className="smr-card__image"
        imageIds={images}
        placeholder={placeholder ?? placeholderImage}
      />
    </div>
  );
}

export default memo(CardThumb);
